import User from "@/services/api/authUser";

class Nazgul {
  constructor() {
    this.fetch = fetch;
    const DEVICE_KEY = "device_id";
    this.device_id = localStorage.getItem(DEVICE_KEY);
    if (!this.device_id) {
      this.device_id = this._uuidv4();
      localStorage.setItem(DEVICE_KEY, this.device_id);
    }
  }

  report(event, type = "") {
    const data = {
      event,
      type,
      device_id: this.device_id,
      user_id: User.id || null,
      path: window.location.href
    };

    if (process.env.NODE_ENV !== "development") {
      fetch(`${process.env.VUE_APP_SUARON_REPORTING}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      });
    } else {
      // eslint-disable-next-line
      console.log(data);
    }
  }

  _uuidv4() {
    // https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  }
}

export default new Nazgul();
